import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Style
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ManageListing.css';

// Component
import SideMenu from '../../components/ManageListing/SideMenu';
import PanelWrapper from '../../components/ManageListing/PanelWrapper';
import Loader from '../../components/Loader';
// Graphql
import ManageListingsQuery from './manageListing.graphql';

class ManageListing extends React.Component {
  static propTypes = {
    ManageListingsData: PropTypes.shape({
      loading: PropTypes.bool,
      ManageListings: PropTypes.array
    })
  };

  static defaultProps = {
    ManageListingsData: {
      loading: true,
      ManageListings: []
    }
  }

  render() {
    const { ManageListingsData = {} } = this.props;
    const ManageListings = ManageListingsData.ManageListings;

    const rows = ManageListings && ManageListings.results ? ManageListings.results : [];
    const published = rows.filter(item => item.isPublished).length;
    const pending = rows.filter(item => item.listApprovalStatus !== 'approved').length;
    return (
      <Grid fluid className={'dashBoardContainer'}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'dashBoardListingGrid'}>
              <SideMenu />
              <div className="hostPortal">
                <div className="hostPortalHero"><div><span className="hostEyebrow">Panel de anfitrión</span><h1>Haz que tu propuesta cuente.</h1><p>Administra alojamientos, experiencias, disponibilidad y reservas desde aquí.</p></div><div className={s.heroActions}><a className={s.bankAction} href="/user/bank-account">Cuenta bancaria</a><a className="hostPrimaryAction" href="/become-a-host/experience">+ Nueva experiencia</a></div></div>
                <div className="hostStats"><div><b>{ManageListings && ManageListings.userListingCount || 0}</b><span>Publicaciones</span></div><div><b>{published}</b><span>Publicadas</span></div><div><b>{pending}</b><span>En revisión</span></div></div>
                {
                  !ManageListings && <Loader type={"text"} />
                }
                {
                  ManageListings && <PanelWrapper data={ManageListingsData} />
                }
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}


export default compose(
  withStyles(s),
  graphql(ManageListingsQuery, {
    name: 'ManageListingsData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ManageListing);
